import { render } from "./pageAccess.vue?vue&type=template&id=5f594195"
import script from "./pageAccess.vue?vue&type=script&lang=js"
export * from "./pageAccess.vue?vue&type=script&lang=js"

import "./pageAccess.vue?vue&type=style&index=0&id=5f594195&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__